export default from './empty-states';



// WEBPACK FOOTER //
// ./app/components/empty-states/index.js